import { Carousel2, MovieCard } from '@intigral/ui';
import { COMPONENT_TYPES } from '@libs/constants';
import { useRef } from 'react';
import h, { getCountry } from '../../helpers/common';
import f from '../../helpers/formatter';
import f2 from '../../helpers/formatter2';
import { __ } from '../../translations';
import { TransformedVOD } from '../../utils/vodTransformer';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import VodItem from '../elements/VodItem';

type GenericVodCarouselProps = {
    id?: string;
    isLoading?: boolean;
    language: string;
    title: string;
    name: string;
    meta: any;
    content: TransformedVOD[];
    data_stream: string;
    params: any;
    carousel?: Carousel;
    data?: any;
};

export const GenericVodCarousel = ({
    id,
    isLoading,
    language,
    title,
    name,
    meta,
    content,
    data,
    ...props
}: GenericVodCarouselProps) => {
    const sliderElement = useRef(null);
    const componentId = id ?? '';

    const countryCode = getCountry().toLowerCase();
    const countryName = __(`country_${countryCode}`);

    const placeHoldersValues = {};
    placeHoldersValues[`country`] = countryName;

    const lastWatchedTitle = data?.watchedTitle
        ? h.getLang() === 'ar'
            ? data?.watchedTitleLocalized?.ar || data.watchedTitle
            : data.watchedTitle
        : '';

    const componentTitle = `${__(title) ?? ''}`.replace(/\{(.*?)\}/g, '<$1>'); // The goal of the replace is to convert any placeholder like {X} to <X> so that the formater f2.getPlaceholderValue can work as expected.
    const formattedTitle = f2.getPlaceholderValue(componentTitle, { country: countryName, X: lastWatchedTitle });

    // unique class name to address the swiper pagination
    const pagingId = `component-${Math.random().toString(36).slice(2, 11)}`;
    const paginationClass = `pagination-${pagingId}`;
    const maxItems = props?.carousel?.maxItems;
    const contents = maxItems && content?.length > maxItems ? content?.slice(0, maxItems) : content;

    return (
        <div className="container full-width" ref={sliderElement} id={componentId} data-test-id={props?.carousel?.id}>
            {contents && contents?.length ? (
                <SectionHeaderWithPagination
                    title={formattedTitle}
                    className={`${paginationClass}`}
                    seeAllText={__('home_carousel_see_all')}
                    seeAllUrl={
                        f.getComponentSeeAllLink(meta, props.params, null, props?.carousel, formattedTitle) as string
                    }
                    isLoading={isLoading}
                />
            ) : (
                <SectionHeaderWithPagination isLoading={isLoading} />
            )}

            <Carousel2
                isLoading={isLoading}
                swiperSettings={{
                    dir: h.getLang() == 'ar' ? 'rtl' : 'ltr',
                    pagination: {
                        el: `.${paginationClass}`,
                        clickable: true,
                    },
                    virtual: {
                        addSlidesBefore: 6,
                        addSlidesAfter: 6,
                    },
                }}
                dir={h.getLang() == 'ar' ? 'rtl' : 'ltr'}
                top10={props?.carousel?.wcpType === 'TOP_TEN_PORTRAIT' ? true : false}
            >
                {isLoading ? (
                    <MovieCard isLoading />
                ) : (
                    contents?.map((item, index) => {
                        return (
                            <VodItem
                                key={index}
                                index={index}
                                item={item}
                                meta={item?.meta || {}}
                                componentType={COMPONENT_TYPES.VOD_CAROUSEL}
                                componentName={name}
                                type={props?.carousel?.type}
                            />
                        );
                    })
                )}
            </Carousel2>
        </div>
    );
};
